module.exports = __webpack_public_path__ + "img/visitor-avatar.d9ece367.png";